var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresidentsDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#542B2B;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.9,37.6h-1.8V19c0-0.6-0.4-1-1-1H30.9c-0.6,0-1,0.4-1,1v18.6h-1.8c-0.6,0-1.2,0.3-1.7,0.7 c-0.5,0.5-0.7,1.1-0.7,1.7c0,1.1,0.8,3.2,2.4,3.2h28.8c1.6,0,2.4-2.1,2.4-3.2C59.3,38.7,58.2,37.6,56.9,37.6z M56.8,41.2H28.2 C28,41,27.7,40.4,27.7,40c0-0.1,0.1-0.2,0.1-0.3c0,0,0.1-0.1,0.3-0.1h2.8c0.6,0,1-0.4,1-1V20h21.2v18.6c0,0.6,0.4,1,1,1h2.8 c0.2,0,0.4,0.2,0.4,0.4C57.3,40.4,57,41.1,56.8,41.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,44.7c0,0,1.1,0.1,1.1,0.6c-0.1,2.3,2.6,11.7,2.8,13.8c0.2,2.8,1.4,3.7,3.6,4c4,0.7,3.7,0.1,4.6-0.4 c1.9-1,3.6,0.5,3.9,0.8c0.4,0.2,3-1,3.9-1.1s2.4-1,2.9-3s0.5-5.2,1.3-6.2s0.5-7.7,1-7.8s1.5,0,1.5,0s-1.5,8.4-1.7,9.9 c-0.2,1.5-0.5,3-0.5,3.9s0,4.2-0.2,4.4c-0.2,0.2-1.7,1.1-1.9,1.9c-0.2,0.8-2.8,6.2-6,6.6c-0.8,0.1-1.2,1.1-3.1,0.5 c-1.9-0.6-4.1-1.4-4.5-2.1S36,69.6,35.3,69c-0.7-0.6-1.7-2.7-2.1-4s-1.8-2-1.7-4c0.1-2-1.2-7.5-1.2-7.5L29.2,44.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresidentsDay);
export default __webpack_public_path__ + "static/media/PresidentsDay.68510c2bbfafea911aa6c01ce0eb8f05.svg";
export { ForwardRef as ReactComponent };